module.exports = __webpack_public_path__ + "static/media/em-222.bc89620f.png";